import { Box } from "@bcc-ui/ui-components";
import React from "react";

import { getJobStatusBackgroundColor, getJobStatusIcon, jobStatusTriggerText } from "./importJobStatusUtils";
import style from "components/asset-management-system/custom-views/tabs/overview/cards/total-imported-assets-card/total-imported-assets-card.scss";
import { AssetImportJob } from "services/asset-management/AssetImportJobService";

interface JobStatusBadgeProps {
    job: AssetImportJob;
}

export const JobStatusBadge = (props: JobStatusBadgeProps) => {
    return (
        <Box
            verticalAlignment={"Center"}
            horizontalAlignment={"Center"}
            gap={"Xxxs"}
            className={style.badgeBase}
            style={{ backgroundColor: getJobStatusBackgroundColor(props.job.status) }}
            datatype="ASSETS_IMPORTING"
        >
            {getJobStatusIcon(props.job.status)}
            {jobStatusTriggerText(props.job, 1)}
        </Box>
    );
};
